/* tslint:disable */
type FormType =
  '10-Q' |
  '10-K' |
  '8-K' |
  '10-K/A' |
  '10-Q/A' |
  '8-K/A';
module FormType {
  export const _10_Q: FormType = '10-Q';
  export const _10_K: FormType = '10-K';
  export const _8_K: FormType = '8-K';
  export const _10_K_A: FormType = '10-K/A';
  export const _10_Q_A: FormType = '10-Q/A';
  export const _8_K_A: FormType = '8-K/A';
  export function values(): FormType[] {
    return [
      _10_Q,
      _10_K,
      _8_K,
      _10_K_A,
      _10_Q_A,
      _8_K_A
    ];
  }
}

export { FormType }